export enum UserType {
    None = 0,
    EhandelUser = 1,
    FerrodoUser = 2,
}